import * as actions from '../../actions/actionTypes';
//
const initialState = [];
//
export default function sd0108(state = initialState, action) {
  switch (action.type) {
    case actions.SET_SD0108_SUCCESS:
      if (action.payload) {
        return action.payload;
      } else {
        return state;
      }
    case actions.SET_SD0108_FAILURE:
      return state;
    default:
      return state;
  }
}
